import { render, staticRenderFns } from "./ItemParts.vue?vue&type=template&id=7586ae62&scoped=true&"
import script from "./ItemParts.vue?vue&type=script&lang=js&"
export * from "./ItemParts.vue?vue&type=script&lang=js&"
import style0 from "./ItemParts.vue?vue&type=style&index=0&id=7586ae62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7586ae62",
  null
  
)

export default component.exports